import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

const comingSoon = (heading: string) => ({
  title: heading,
  loadComponent: () => import('./shared/components/coming-soon/coming-soon.component'),
  data: { heading },
});

export const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./core/auth/auth.routes') },
  {
    path: '',
    loadComponent: () => import('./core/layout/shell/shell.component'),
    canMatch: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'template-management',
        title: 'Template Management',
        loadChildren: () => import('./features/template-management/template-management.routes'),
      },
      { path: 'dashboard', ...comingSoon('Dashboard') },
      { path: 'audit-planning', ...comingSoon('Audit Planning') },
      { path: 'capa-tracking', ...comingSoon('CAPA Tracking') },
      { path: 'supplier-management', ...comingSoon('Supplier Management') },
      { path: 'user-management', ...comingSoon('User Management') },
    ],
  },
  { path: '**', redirectTo: '' },
];
